(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('App', App);

    /* @ngInject */
    function App($resource) {
        var resourceUrl = 'api/system/apps/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByName': {
                url: 'api/system/apps/:id?name=true',
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
